import React from "react";
import { useParams } from "react-router-dom";

import AgroTradeHeader from "../components/Header";
import LandingFooter from "../../landing/components/Footer";

function ServiceDetailPage() {
    const { id } = useParams();

    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />
            <main className="flex-1">
                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0 grid gap-10 lg:grid-cols-[minmax(260px,320px)_1fr]">
                    <section>
                        <h1 className="text-2xl font-semibold mb-4">Сервис: {id}</h1>
                        <p className="text-sm text-[#4b5563] mb-4">
                            Здесь отображается основная информация о выбранном сервисе платформы
                            AgroTrade: цели, условия, требования и необходимые документы.
                        </p>
                        <ul className="list-disc list-inside text-sm text-[#4b5563] space-y-1">
                            <li>Описание услуги и её преимущества для фермера или покупателя.</li>
                            <li>Перечень шагов по оказанию услуги.</li>
                            <li>Контактные данные менеджера или отдела сопровождения.</li>
                        </ul>
                    </section>

                    <section className="space-y-4">
                        <div className="rounded-xl border border-[#e5e7eb] bg-white p-4">
                            <h2 className="text-lg font-semibold mb-2">Заявка на услугу</h2>
                            <p className="text-xs text-[#6b7280] mb-3">
                                Заполните форму, и наш менеджер свяжется с вами для уточнения деталей.
                            </p>
                            <form className="space-y-3">
                                <input
                                    type="text"
                                    placeholder="Ваше имя"
                                    className="w-full rounded-md border border-[#d1d5db] px-3 py-2 text-sm focus:outline-none focus:border-[#147F26]"
                                />
                                <input
                                    type="text"
                                    placeholder="Контактный телефон"
                                    className="w-full rounded-md border border-[#d1d5db] px-3 py-2 text-sm focus:outline-none focus:border-[#147F26]"
                                />
                                <textarea
                                    rows={4}
                                    placeholder="Кратко опишите запрос"
                                    className="w-full rounded-md border border-[#d1d5db] px-3 py-2 text-sm focus:outline-none focus:border-[#147F26]"
                                />
                                <button
                                    type="submit"
                                    className="inline-flex items-center justify-center rounded-full bg-[#147F26] px-6 py-2 text-sm font-medium text-white hover:bg-[#0f5d1c] transition"
                                >
                                    Заказать услугу
                                </button>
                            </form>
                        </div>

                        <div className="rounded-xl border border-dashed border-[#d1d5db] bg-white/60 p-4 text-xs text-[#6b7280]">
                            Здесь может быть размещена дополнительная информация по сервису, тарифы
                            или FAQ.
                        </div>
                    </section>
                </div>
            </main>
            <LandingFooter />
        </div>
    );
}

export default ServiceDetailPage;

